/**
 * The Settings > Inspections route (SWOOP-378). Shared by the route's `beforeLoad` and the page's `<ModuleGate>`,
 * which both look its owning module up in the registry (`moduleAreaForPath`) rather than naming it.
 */
export const INSPECTION_SETTINGS_PATH = '/settings/inspections';

/**
 * Settings > Inspections is gated on `inspection-templates:manage` (SWOOP-387): the templates API refuses
 * everyone else, so gating on a broader code (`tenants:read`, held by the Account Manager) would show a page
 * that only ever returns a 403. The Tenant Admin holds it; the Inspector holds only `inspection-templates:list`,
 * which is how the ticket's "an inspector cannot see Settings > Inspections" holds.
 */
export const INSPECTION_SETTINGS_PERMISSION = 'inspection-templates:manage';
